<template>
  <div class="container">
    <timechart v-if="loaded" :chartdata="chartdata" :options="options"/>
  </div>
</template>

<script>
import TimeChart from "./TimeChart.js";
import { API } from "aws-amplify";

export default {
  name: "TimeChart4Container",
  components: {
    timechart: TimeChart
  },
  props: ["collection_id", "collection_type", "user", "chart_id", "label", "stacked", "instance_num"],
  data: () => ({
    loaded: false,
    chartdata: null,
    maindata: null,
    newdata: null,
    options: {
      scales: {
        xAxes: [
          {
            type: "time",
            time: {
              unit: 'day',
                    displayFormats: {
           'millisecond': 'MMM DD',
           'second': 'MMM DD',
           'minute': 'MMM DD',
           'hour': 'MMM DD',
           'day': 'MMM DD',
           'week': 'MMM DD',
           'month': 'MMM DD',
           'quarter': 'MMM DD',
           'year': 'MMM DD'
                    }
                }
          }
        ],
        yAxes: [
          {
            stacked: true
          }
        ]
      },
      responsive: true,
      maintainAspectRatio: false,
      gradient: null,
      gradient2: null

    }
  }),
  async mounted() {
    this.loaded = false;

// var ctx = document.getElementById('line-chart').getContext("2d")
//     this.gradient = ctx.createLinearGradient(0, 0, 0, 450)
//     this.gradient2 = ctx.createLinearGradient(0, 0, 0, 450)
    // this.gradient = this.$children[0].$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    // this.gradient2 = this.$children[0].$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

    // this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)')
    // this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
    // this.gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
    
    // this.gradient2.addColorStop(0, 'rgba(0, 231, 255, 0.9)')
    // this.gradient2.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)');
    // this.gradient2.addColorStop(1, 'rgba(0, 231, 255, 0)');
console.log("stacked",this.stacked)
console.log("chartid",this.chart_id)
     if (this.stacked=="false") {
       this.options.scales.yAxes[0].stacked = false;
     }  

    try {
      // console.log("TCC2: I am here");

      if (this.maindata == null) {
        var tries = 2;
        while (tries > 0) {
          var new_collection_id = this.collection_id;
          if (this.instance_num === undefined) {
          } else
          {
            new_collection_id = this.collection_id+'-'+this.instance_num;
          }
          await API.get("dbcsiAPI", `/dbcsi/${new_collection_id}/${this.collection_type}/${this.chart_id}`)
            .then(response => {
              // console.log("TCC2: I am here3");
              this.maindata = response.data;
              this.newdata = [[], [], [], []];

              for (var ii = 0; ii < this.maindata.length; ii++) {
                this.newdata[0].push({
                  x: this.maindata[ii].x,
                  y: this.maindata[ii].y1
                });
                this.newdata[1].push({
                  x: this.maindata[ii].x,
                  y: this.maindata[ii].y2
                });
                this.newdata[2].push({
                  x: this.maindata[ii].x,
                  y: this.maindata[ii].y3
                });
                this.newdata[3].push({
                  x: this.maindata[ii].x,
                  y: this.maindata[ii].y4
                });
              }

              tries = 0;
              // console.log(this.newdata[0]);
            })
            .catch(error => {
              console.log("TCC2 Error:", error);
            });
          tries -= 1;
        }
      }

      // need to convert [{x,y1,y2},...] into [{x,y:y1}] and [{x,y:y2}].  Maybe support 2,3,4,...
      // need to update url to test/collection_id
      // need to make labels an array
      // need option to stack or not

      this.chartdata = {
        datasets: [
          {
            label: this.label.split(":")[0],
            data: this.newdata[0],
            borderColor: "#ff0000",
            backgroundColor: "rgba(255, 0,0, 0.25)",
            borderWidth: 1,
            pointRadius: 1,
            fill: false
          // borderColor: '#FC2525',
          // pointBackgroundColor: 'white',
          // borderWidth: 1,
          // pointBorderColor: 'white'
          // backgroundColor: this.gradient
          },
          {
            label: this.label.split(":")[1],
            data: this.newdata[1],
            // borderColor: "#3e95cd",
            borderColor: "rgba(0, 0, 255, 1)",
            backgroundColor: "rgba(0, 0, 255, 0.25)",
            // borderColor: "rgba(0, 231, 255, 1)",
            // backgroundColor: "rgba(0, 231, 255, 0.5)",
            borderWidth: 1,
            pointRadius: 1,            
            fill: false
          // borderColor: '#05CBE1',
          // pointBackgroundColor: 'white',
          // pointBorderColor: 'white'
          // borderWidth: 1
          // backgroundColor: this.gradient2

          },
          {
            label: this.label.split(":")[2],
            data: this.newdata[2],
            // borderColor: "#3e95cd",
            borderColor: "rgba(0, 255, 0, 1)",
            backgroundColor: "rgba(0, 255, 0, 0.25)",
            // borderColor: "rgba(0, 231, 255, 1)",
            // backgroundColor: "rgba(0, 231, 255, 0.5)",
            borderWidth: 1,
            pointRadius: 1,            
            fill: false
          // borderColor: '#05CBE1',
          // pointBackgroundColor: 'white',
          // pointBorderColor: 'white'
          // borderWidth: 1
          // backgroundColor: this.gradient2

          },
          {
            label: this.label.split(":")[3],
            data: this.newdata[3],
            // borderColor: "#3e95cd",
            // borderColor: "rgba(150, 75, 0, 1)",
            // backgroundColor: "rgba(150, 75, 0, 0.25)",
            // borderColor: "rgba(255, 255, 0, 1)",
            // backgroundColor: "rgba(255, 255, 0, 0.25)",
            borderColor: "orange",
            backgroundColor: "orange",
            borderWidth: 1,
            pointRadius: 1,            
            fill: false
          // borderColor: '#05CBE1',
          // pointBackgroundColor: 'white',
          // pointBorderColor: 'white'
          // borderWidth: 1
          // backgroundColor: this.gradient2

          }

        ]
      };
      this.loaded = true;
    } catch (e) {
      console.error(e);
    }
  }
};
</script>